export default __webpack_public_path__ + "static/media/metacritic.f98a26f3.png";